module.exports = __webpack_public_path__ + "79d843d21901da450fdf69986e1ed15b.svg";